import { CommonModule } from '@angular/common';
import { BarChartModule } from 'ChartApp/ts/features/bar-chart/bar-chart.module';
import { GeneralChartModule } from 'ChartApp/ts/features/general-chart/general-chart.module';
import { SingleDatePickerModule } from 'NewAngular/features/components/date-controls/single-date-picker/single-date-picker.module';
import { SimpleDropdownModule } from 'NewAngular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { LoadingModalModule } from 'NewAngular/features/components/modals/loading-modal/loading-modal.module';
import { PaginationControlsModule } from 'NewAngular/features/components/pagination/pagination-controls/pagination-controls.module';
import { PdfTitleModalModule } from 'NewAngular/features/components/pdf-title-modal/pdf-title-modal.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { AutocompleteInPlaceModule } from 'SearchApp/ts/features/autocomplete-in-place/autocomplete-in-place.module';
import { ModuleUpsellModule } from 'SecuritiesApp/ts/features/module-upsell/module-upsell.module';
import * as i0 from "@angular/core";
export class AttributionAbsoluteModule {
}
AttributionAbsoluteModule.ɵfac = function AttributionAbsoluteModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AttributionAbsoluteModule)(); };
AttributionAbsoluteModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AttributionAbsoluteModule });
AttributionAbsoluteModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AutocompleteInPlaceModule,
        BarChartModule,
        CommonModule,
        DisabledModule,
        GeneralChartModule,
        HelpModalModule,
        IconModule,
        LoadingModalModule,
        LoadingSymbolModule,
        ModuleUpsellModule,
        PaginationControlsModule,
        PdfTitleModalModule,
        SingleSelectDropdownModule,
        SingleDatePickerModule,
        SimpleDropdownModule,
        TooltipModule] });
